import MemberDialog from 'components/Application/TeamMemberForm/MemberDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { CONFIRM_REMOVE_PI_DELEGATION, TEAM_MEMBER_EXIST, THREE_SITE_PI_ALLOWED } from 'utility/frontendMessage';
import { compareEmail, piDelegationColumns } from 'utility/general';

const SLayout = styled.div``;

const PiDelegationEdit = ({
    isTableLoading,
    delegationData,
    siteDisplay,
    siteInfoId,
    onPiDelegateAdd = () => null,
    onPiDelegateUpdate = () => null,
    onPiDelegateRemove = () => null,
}) => {
    const [isPiDelegateAddShow, setPiDelegationAddShow] = useState(false);
    const [isPiDelegationEdit, setPiDelegationEdit] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const showDialog = useDialog();

    const onPiDelegationAdd = async (data) => {
        const isExist = delegationData.some((item) => compareEmail(item.email, data.email));

        if (isExist) {
            return showDialog({
                description: TEAM_MEMBER_EXIST,
                disableCancelButton: true,
            });
        }

        onPiDelegateAdd({ institution: siteDisplay, data, siteInfoId });
        setPiDelegationAddShow(false);
    };

    const onEdit = (data) => {
        setSelectedRow(data);
        setPiDelegationAddShow(true);
        setPiDelegationEdit(true);
    };

    const onPiDelegationSubmit = (data) => {
        if (!isPiDelegationEdit) {
            const isExist = delegationData.some((item) => compareEmail(item.email, data.email));

            if (isExist) {
                return showDialog({
                    description: TEAM_MEMBER_EXIST,
                    disableCancelButton: true,
                });
            }
        }

        onPiDelegateUpdate({ institution: siteDisplay, data, siteInfoId });
        setPiDelegationAddShow(false);
    };

    const onPiDelegateDelete = async (data) => {
        const isConfirm = await showDialog({
            description: CONFIRM_REMOVE_PI_DELEGATION,
        });

        if (isConfirm) {
            onPiDelegateRemove({ institution: siteDisplay, data, siteInfoId });
        }
    };

    return (
        <SLayout>
            {isPiDelegateAddShow && (
                <MemberDialog
                    title={`Adding delegation for site (${siteDisplay})`}
                    isDelegateDialog
                    disablePosition
                    restrictApplicant
                    selectedRow={selectedRow}
                    onDialogCancel={() => setPiDelegationAddShow(false)}
                    onCreateSubmit={onPiDelegationAdd}
                    onEditSubmit={onPiDelegationSubmit}
                    isEdit={isPiDelegationEdit}
                />
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <TextHeader>Site ({siteDisplay}) delegations</TextHeader>
                <CustomButton
                    onClick={() => {
                        if (delegationData.length >= 3) {
                            return showDialog({
                                description: THREE_SITE_PI_ALLOWED,
                                disableCancelButton: true,
                            });
                        }

                        setPiDelegationEdit(false);
                        setSelectedRow({});
                        setPiDelegationAddShow(true);
                    }}
                >
                    Add
                </CustomButton>
            </div>
            <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
                <CustomTable
                    fullWidthTable
                    columns={piDelegationColumns}
                    rows={delegationData}
                    isDeleteAllow
                    isEditAllow
                    loading={isTableLoading}
                    disableDeleteConfirm
                    onDelete={onPiDelegateDelete}
                    onEdit={onEdit}
                />
            </div>
        </SLayout>
    );
};

export default PiDelegationEdit;
